import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { allArticles } from '@/mocks/content';

export default function ArticleListPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '资讯动态 - 91在线视频',
            description: '91在线视频最新资讯动态，包括使用教程、功能更新、内容推荐、安全公告等。实时了解平台最新消息。',
            url: 'https://www.91zaixianshipin.com/article',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.91zaixianshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '资讯动态',
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <Link to="/" className="hover:text-accent-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">资讯动态</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
              资讯动态
            </h1>
            <p className="text-foreground-500 max-w-[600px]">
              获取91在线视频最新资讯，了解平台动态、使用教程和安全公告，让您更好地使用我们的服务。
            </p>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12 md:py-16">
          <div className="flex flex-wrap gap-3 mb-10">
            <button className="px-4 py-2 bg-primary-500 text-white rounded-full text-sm font-medium whitespace-nowrap cursor-pointer">全部</button>
            <button className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 whitespace-nowrap cursor-pointer">使用教程</button>
            <button className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 whitespace-nowrap cursor-pointer">功能更新</button>
            <button className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 whitespace-nowrap cursor-pointer">内容推荐</button>
            <button className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 whitespace-nowrap cursor-pointer">安全公告</button>
            <button className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 whitespace-nowrap cursor-pointer">站内公告</button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {allArticles.map((article) => {
              const thumbImages: Record<number, string> = {
                1: 'https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20showing%20video%20app%20interface%2C%20minimalist%20tech%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20soft%20shadows%2C%20neutral%20background&width=600&height=400&seq=art-list-01&orientation=landscape',
                2: 'https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20with%20elegant%20gold%20accents%2C%20luxury%20lifestyle%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20sophisticated%20visual%2C%20clean%20composition&width=600&height=400&seq=art-list-02&orientation=landscape',
                3: 'https://readdy.ai/api/search-image?query=Film%20reel%20and%20cinema%20concept%2C%20artistic%20movie%20themed%20still%20life%2C%20warm%20vintage%20tones%2C%20creative%20composition%2C%20soft%20dramatic%20lighting%2C%20cinematography%20aesthetic&width=600&height=400&seq=art-list-03&orientation=landscape',
                4: 'https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20clean%20modern%20design%2C%20professional%20tech%20aesthetic%2C%20warm%20tones%2C%20minimalist%20style&width=600&height=400&seq=art-list-04&orientation=landscape',
                5: 'https://readdy.ai/api/search-image?query=Modern%20TV%20screen%20showing%20video%20settings%20interface%2C%20clean%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20minimalist%20living%20room%20setup%2C%20professional%20product%20photography&width=600&height=400&seq=art-list-05&orientation=landscape',
                6: 'https://readdy.ai/api/search-image?query=Community%20guidelines%20concept%20illustration%2C%20warm%20harmonious%20colors%2C%20abstract%20people%20figures%2C%20clean%20modern%20design%2C%20friendly%20atmosphere%2C%20soft%20gradients&width=600&height=400&seq=art-list-06&orientation=landscape',
              };
              const thumbUrl = thumbImages[article.id] || thumbImages[1];

              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group block rounded-2xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all duration-300 border border-background-200/70 cursor-pointer"
                >
                  <div className="relative aspect-[3/2] overflow-hidden">
                    <img
                      src={thumbUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 text-xs text-foreground-400 mb-2">
                      <span>{article.date}</span>
                      <span>·</span>
                      <span>{article.author}</span>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}